import { UseMutationResult } from '@tanstack/react-query';
import { endPointUrls } from 'core/constants/endPointUrls';
import toastHandler from 'core/helpers/toast/toast';
import useMutationHook from 'core/hooks/masterQuery/useMutationHook';
import useMasterQueryUrlParam from 'core/hooks/useMasterQueryUrlParam';
import api from 'core/services/fetch-api/useApi';
import { setApiCatcherFormErrors } from 'core/store/slice/mainInfo/mainInfoSlice';
import { useDispatch } from 'react-redux';

export const useRegisterQuery = () => {
	const dispatch = useDispatch();
	const { setUrlParam } = useMasterQueryUrlParam();

	return useMutationHook(
		[endPointUrls.REGISTER],
		(data: any) => api.post(endPointUrls.REGISTER, data),
		{
			onSuccess: (res: any) => {
				const payload = JSON.parse(res.config?.data);

				if (res?.status === 200) {
					toastHandler('success', res?.data.message);
					setUrlParam({ page: 3, email: payload?.email });
					dispatch(setApiCatcherFormErrors([]));
				}
			},
		}
	) as UseMutationResult;
};
